import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { getAvailableSlots, getCustomerAvailableSlots, getHighlightedDays } from './api';
import { AvailableSlotsResult, DayAvailability, TimeSlot } from './entity';

export const useAvailableSlotsQuery = (date: string | undefined, serviceId: string | undefined) => {
  return useQuery<AvailableSlotsResult>({
    queryKey: ['availableSlots', date, serviceId],
    queryFn: () => getAvailableSlots(date!, serviceId!),
    enabled: !!(date && serviceId),
    staleTime: 60 * 1000,
    placeholderData: keepPreviousData,
    retry: false,
  });
};

export const useHighlightedDaysQuery = (
  month: string | undefined,
  serviceId: string | undefined,
) => {
  return useQuery<Record<string, DayAvailability>>({
    queryKey: ['highlightedDays', month, serviceId],
    queryFn: () => getHighlightedDays(month!, serviceId!),
    enabled: !!(month && serviceId),
    staleTime: 5 * 60 * 1000,
    placeholderData: keepPreviousData,
  });
};

export const useCustomerAvailableSlotsQuery = (
  date: string | undefined,
  serviceId: string | undefined,
  enabled = true,
) => {
  return useQuery<TimeSlot[]>({
    queryKey: ['customerAvailableSlots', date, serviceId],
    queryFn: () => getCustomerAvailableSlots(date!, serviceId!),
    enabled: !!(date && serviceId && enabled),
    staleTime: 60 * 1000,
    placeholderData: keepPreviousData,
  });
};
